import { render, staticRenderFns } from "./creditorPieChart.vue?vue&type=template&id=044aef58"
import script from "./creditorPieChart.vue?vue&type=script&lang=js"
export * from "./creditorPieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports